import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index'

// import Home from '@/pages/Home'
import About from '@/pages/about'
import myPlan from '@/pages/myPlan'
import addPlan from '@/pages/addPlan'
import riskTest from '@/pages/riskTest'
import planResult from '@/pages/planResult'


Vue.use(Router);
Vue.use(require('vue-wechat-title'));

export default new Router({
  mode: 'history',
  base: '/financeTools',
  routes: [{
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: '银行理财专区'
      },

    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: {
        title: '相关说明'
      },

    },
    {
      path: '/myPlan',
      name: 'myPlan',
      component: myPlan,
      meta: {
        title: '我的存款计划'
      },

    },

    {
      path: '/riskTest',
      name: 'riskTest',
      component: riskTest,
      meta: {
        title: '风险测评'
      },

    },

    {
      path: '/addPlan',
      name: 'addPlan',
      component: addPlan,
      meta: {
        title: '添加存款计划'
      },

    },
    {
      path: '/planResult',
      name: 'planResult',
      component: planResult,
      meta: {
        title: '存款计划结果展示'
      },

    },


    // {path: '/complaint', name: 'Complaint', component: Complaint, meta: {title: '投诉'}},

  ],
  scrollBehavior(to, from, savedPosition) {
    return savedPosition ? {
      x: savedPosition.x,
      y: savedPosition.y
    } : {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js